import { useApiQuery } from 'hooks/useApiQuery'
import { useCurrentStateStore } from 'stores/useCurrentStateStore'

export const useGetPromotions = () => {
  const { currentStateId } = useCurrentStateStore()

  return useApiQuery({
    path: '/admin/promotions',
    method: 'get',
    queryKey: ['/admin/promotions'],
    queryArgs: {},
    requestHeaders: currentStateId
      ? { 'Current-State-Id': currentStateId.toString() }
      : undefined,
  })
}
